import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import TooltipLable from './tooltip-label';
import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import messages from './messages';

const CustomTooltipNewOrders = ({ payload = emptyArray }) => {
  const selectedDate = payload?.[0]?.payload.interval;
  const newCount = <FormattedNumber value={payload?.[0]?.payload.newCount || 0} />;
  const shippedCount = <FormattedNumber value={payload?.[0]?.payload.shippedCount || 0} />;

  return (
    <>
      <TooltipLable selectedDate={selectedDate} />
      <div className={style.content}>
        <FormattedMessage
          {...messages.newOrdersShippedRatio}
          values={{
            shippedCount,
            newCount,
          }}
        />
      </div>
    </>
  );
};

CustomTooltipNewOrders.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        amount: PropTypes.number,
        interval: PropTypes.string,
        itemCount: PropTypes.number,
        newCount: PropTypes.number,
        shippedCount: PropTypes.number,
        unshippedCount: PropTypes.number,
      }),
    }),
  ),
};

export default CustomTooltipNewOrders;
